module.exports = __webpack_public_path__ + "img/photos/finances/02.jpg";